import { L } from '@lib';
import { InventoryService, SupplierLookup } from '@services';
import { Select } from 'antd';
import { debounce } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';

interface IProps {
  value?: string | string[];
  onChange?: (value: any) => void;
  placeholder?: string;
  allowClear?: boolean;
  disabled?: boolean;
  size?: 'small' | 'middle' | 'large';
  style?: React.CSSProperties;
  preselected?: SupplierLookup;
  mode?: 'multiple';
  maxTagCount?: number | 'responsive';
}

export const SupplierSelect: React.FC<IProps> = ({
  value,
  onChange,
  placeholder,
  allowClear = true,
  disabled,
  size,
  style,
  preselected,
  mode,
  maxTagCount,
}) => {
  const [items, setItems] = useState<SupplierLookup[]>([]);

  const fetchItems = async (search: string) => {
    try {
      const result = await InventoryService.supplierLookup(search);
      setItems(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchItems('');
  }, []);

  const handleSearch = useMemo(
    () => debounce((text: string) => fetchItems(text || ''), 400),
    []
  );

  const options = useMemo(() => {
    const base = items.map((s) => ({ label: s.name, value: s.id }));
    if (preselected && !base.some((b) => b.value === preselected.id)) {
      return [{ label: preselected.name, value: preselected.id }, ...base];
    }
    return base;
  }, [items, preselected]);

  return (
    <Select
      mode={mode}
      maxTagCount={maxTagCount}
      showSearch
      allowClear={allowClear}
      filterOption={false}
      notFoundContent={null}
      style={{ width: '100%', ...style }}
      size={size}
      disabled={disabled}
      value={value}
      options={options}
      onSearch={handleSearch}
      onChange={onChange}
      placeholder={placeholder || L('Select supplier')}
    />
  );
};
